/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Termsagreed_Allocationstatus_Declined3Inputs */

const en_coinvestments_termsagreed_allocationstatus_declined3 = /** @type {(inputs: Coinvestments_Termsagreed_Allocationstatus_Declined3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Declined`)
};

/**
* | output |
* | --- |
* | "Declined" |
*
* @param {Coinvestments_Termsagreed_Allocationstatus_Declined3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_termsagreed_allocationstatus_declined3 = /** @type {((inputs?: Coinvestments_Termsagreed_Allocationstatus_Declined3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Termsagreed_Allocationstatus_Declined3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_termsagreed_allocationstatus_declined3(inputs)
});
export { coinvestments_termsagreed_allocationstatus_declined3 as "coInvestments_termsAgreed_allocationStatus_declined" }